const threeLetterPattern = /^[a-z0-9]{3}$/i;

module.exports = {
  validate({ isThreeLetter }) {
    if (typeof(isThreeLetter) !== 'boolean') {
      return { isValid: false, message: 'Must have a boolean isThreeLetter property' };
    }

    return { isValid: true };
  },

  test({ rule: { isThreeLetter }, params: { shopperId } }) {
    if (!shopperId) {
      return false;
    }

    return threeLetterPattern.test(shopperId) === isThreeLetter;
  }
};
